//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { CommonServices } from "@/services/CommonServices";
import * as OM from "@/Model";
import { baseUrl } from '@/config';

class _AdminClient {

  

  /**
 * Gets a list of all users.
 * @return A list of UserListVM objects representing the users.
 */

  



  getAllUsers(showSpinner = true) : Promise<OM.UserListVM[]> {
  return CommonServices.defaultGet<OM.UserListVM[]>(baseUrl + 'api/Admin/GetAllUsers', {  }, showSpinner)
  }

  

  /**
 * Edits a user with the provided details.
 * @param model The user edit model containing the user details.
 * @return An ActionResult indicating the result of the operation.
 */

  



    

    

    


  



  editUser(model : OM.UserEditVM, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/Admin/EditUser', model, { }, showSpinner)
  }

  

  /**
 * Disables a user by their identifier.
 * @param userIdentifier (optional) The identifier of the user to disable.
 * @return An ActionResult indicating the result of the operation.
 */

  



    

    

    


  



  disableUser(userIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Admin/DisableUser', { userIdentifier }, showSpinner)
  }

  

  /**
 * Enables a user by their identifier.
 * @param userIdentifier (optional) The identifier of the user to enable.
 * @return An ActionResult indicating the result of the operation.
 */

  



    

    

    


  



  enableUser(userIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Admin/EnableUser', { userIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  login(model : OM.LanguageCredential, showSpinner = true) : Promise<OM.BaseApiLoginResponse> {
  return CommonServices.defaultPost<OM.BaseApiLoginResponse>(baseUrl + 'api/Admin/Login', model, { }, showSpinner)
  }

  

  



    

    

    


  



  register(model : OM.LanguageCredential, showSpinner = true) : Promise<OM.BaseApiLoginResponse> {
  return CommonServices.defaultPost<OM.BaseApiLoginResponse>(baseUrl + 'api/Admin/Register', model, { }, showSpinner)
  }

  

  



    

    

    


  



  changePassword(newPassword : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Admin/ChangePassword', { newPassword }, showSpinner)
  }

  

  



    

    

    


  



  resetConfirmationCode(username : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Admin/ResetConfirmationCode', { username }, showSpinner)
  }

  

  



    

    

    


  



  refreshToken(tokens : OM.BaseApiLoginResponse, showSpinner = true) : Promise<OM.BaseApiLoginResponse> {
  return CommonServices.defaultPost<OM.BaseApiLoginResponse>(baseUrl + 'api/Admin/RefreshToken', tokens, { }, showSpinner)
  }

  

  



    

    

    


  



  resetPassword(username : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Admin/ResetPassword', { username }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  

    

    

    


  



  confirm(loginIdentifier : string, confirmationCode : string, preferredCulture : string, showSpinner = true) : Promise<OM.BaseApiLoginResponse> {
  return CommonServices.defaultGet<OM.BaseApiLoginResponse>(baseUrl + 'api/Admin/Confirm', { loginIdentifier, confirmationCode, preferredCulture }, showSpinner)
  }
}
export let AdminClient = new _AdminClient();

class _BaseAuthClient {

  

  /**
 * Upgrades the token for the authenticated user.
 * @return A LoggedUserVM object containing the upgraded token.
 */

  



  tokenUpgrade(showSpinner = true) : Promise<OM.LoggedUserVM> {
  return CommonServices.defaultGet<OM.LoggedUserVM>(baseUrl + 'api/BaseAuth/TokenUpgrade', {  }, showSpinner)
  }

  

  /**
 * Registers a new user. This action is not authorized.
 * @param model The registration model.
 * @return An unauthorized response.
 */

  



    

    

    


  



  register(model : OM.LanguageCredential, showSpinner = true) : Promise<OM.BaseApiLoginResponse> {
  return CommonServices.defaultPost<OM.BaseApiLoginResponse>(baseUrl + 'api/BaseAuth/Register', model, { }, showSpinner)
  }

  

  



    

    

    


  



  login(model : OM.LanguageCredential, showSpinner = true) : Promise<OM.BaseApiLoginResponse> {
  return CommonServices.defaultPost<OM.BaseApiLoginResponse>(baseUrl + 'api/BaseAuth/Login', model, { }, showSpinner)
  }

  

  



    

    

    


  



  changePassword(newPassword : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/BaseAuth/ChangePassword', { newPassword }, showSpinner)
  }

  

  



    

    

    


  



  resetConfirmationCode(username : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/BaseAuth/ResetConfirmationCode', { username }, showSpinner)
  }

  

  



    

    

    


  



  refreshToken(tokens : OM.BaseApiLoginResponse, showSpinner = true) : Promise<OM.BaseApiLoginResponse> {
  return CommonServices.defaultPost<OM.BaseApiLoginResponse>(baseUrl + 'api/BaseAuth/RefreshToken', tokens, { }, showSpinner)
  }

  

  



    

    

    


  



  resetPassword(username : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/BaseAuth/ResetPassword', { username }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  

    

    

    


  



  confirm(loginIdentifier : string, confirmationCode : string, preferredCulture : string, showSpinner = true) : Promise<OM.BaseApiLoginResponse> {
  return CommonServices.defaultGet<OM.BaseApiLoginResponse>(baseUrl + 'api/BaseAuth/Confirm', { loginIdentifier, confirmationCode, preferredCulture }, showSpinner)
  }
}
export let BaseAuthClient = new _BaseAuthClient();

class _BaseUserClient {

  

  /**
 * A fake call to action for demonstration purposes.
 * @return A TextIdentifier object.
 */

  



  fakeCallToAction(showSpinner = true) : Promise<OM.TextIdentifier> {
  return CommonServices.defaultGet<OM.TextIdentifier>(baseUrl + 'api/BaseUser/FakeCallToAction', {  }, showSpinner)
  }

  

  



    

    

    


  



  login(model : OM.LanguageCredential, showSpinner = true) : Promise<OM.BaseApiLoginResponse> {
  return CommonServices.defaultPost<OM.BaseApiLoginResponse>(baseUrl + 'api/BaseUser/Login', model, { }, showSpinner)
  }

  

  



    

    

    


  



  register(model : OM.LanguageCredential, showSpinner = true) : Promise<OM.BaseApiLoginResponse> {
  return CommonServices.defaultPost<OM.BaseApiLoginResponse>(baseUrl + 'api/BaseUser/Register', model, { }, showSpinner)
  }

  

  



    

    

    


  



  changePassword(newPassword : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/BaseUser/ChangePassword', { newPassword }, showSpinner)
  }

  

  



    

    

    


  



  resetConfirmationCode(username : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/BaseUser/ResetConfirmationCode', { username }, showSpinner)
  }

  

  



    

    

    


  



  refreshToken(tokens : OM.BaseApiLoginResponse, showSpinner = true) : Promise<OM.BaseApiLoginResponse> {
  return CommonServices.defaultPost<OM.BaseApiLoginResponse>(baseUrl + 'api/BaseUser/RefreshToken', tokens, { }, showSpinner)
  }

  

  



    

    

    


  



  resetPassword(username : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/BaseUser/ResetPassword', { username }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  

    

    

    


  



  confirm(loginIdentifier : string, confirmationCode : string, preferredCulture : string, showSpinner = true) : Promise<OM.BaseApiLoginResponse> {
  return CommonServices.defaultGet<OM.BaseApiLoginResponse>(baseUrl + 'api/BaseUser/Confirm', { loginIdentifier, confirmationCode, preferredCulture }, showSpinner)
  }
}
export let BaseUserClient = new _BaseUserClient();

class _BuildClient {

  

  /**
 * Gets a list of buildings filtered by the specified filter value.
 * @param filterValue (optional) The filter value to apply.
 * @return A list of BuildVm objects.
 */

  



    

    

    


  



  getBuildList(filterValue : OM.BuildingFilterEnum, showSpinner = true) : Promise<OM.BuildVm[]> {
  return CommonServices.defaultGet<OM.BuildVm[]>(baseUrl + 'api/Build/GetBuildList', { filterValue }, showSpinner)
  }

  

  /**
 * Gets a filtered list of buildings based on the search text.
 * @param searchText (optional) The search text to filter by.
 * @return A list of BuildVm objects.
 */

  



    

    

    


  



  getFilteredBuildingList(searchText : string, showSpinner = true) : Promise<OM.BuildVm[]> {
  return CommonServices.defaultGet<OM.BuildVm[]>(baseUrl + 'api/Build/GetFilteredBuildingList', { searchText }, showSpinner)
  }

  

  /**
 * Gets the details of a building by its ID.
 * @param blId (optional) The ID of the building.
 * @return A BuildDetailsVm object containing the building details.
 */

  



    

    

    


  



  getBuildDetails(blId : string, showSpinner = true) : Promise<OM.BuildDetailsVm> {
  return CommonServices.defaultGet<OM.BuildDetailsVm>(baseUrl + 'api/Build/GetBuildDetails', { blId }, showSpinner)
  }

  

  /**
 * Gets a list of vehicles within a specified distance from a building.
 * @param buildLat (optional) The latitude of the building.
 * @param buildLon (optional) The longitude of the building.
 * @param distance (optional) The maximum distance from the building.
 * @return A list of VehicleWithDistanceFromBuildVm objects.
 */

  



    

    

    


  

    

    

    


  

    

    

    


  



  getVehiclesFromBuild(buildLat : number, buildLon : number, distance : number, showSpinner = true) : Promise<OM.VehicleWithDistanceFromBuildVm[]> {
  return CommonServices.defaultGet<OM.VehicleWithDistanceFromBuildVm[]>(baseUrl + 'api/Build/GetVehiclesFromBuild', { buildLat, buildLon, distance }, showSpinner)
  }
}
export let BuildClient = new _BuildClient();

class _TechnicalClient {

  

  /**
 * Gets a list of technical types.
 * @return A list of technical types as strings.
 */

  



  getTechnicalTypeList(showSpinner = true) : Promise<string[]> {
  return CommonServices.defaultGet<string[]>(baseUrl + 'api/Technical/GetTechnicalTypeList', {  }, showSpinner)
  }

  

  /**
 * Gets the details of a technical entity by UID.
 * @param uid (optional) The UID of the technical entity.
 * @return A TechnicalDetailsVm object containing the details of the technical entity.
 */

  



    

    

    


  



  getTechnicalDetails(uid : string, showSpinner = true) : Promise<OM.TechnicalDetailsVm> {
  return CommonServices.defaultGet<OM.TechnicalDetailsVm>(baseUrl + 'api/Technical/GetTechnicalDetails', { uid }, showSpinner)
  }

  

  /**
 * Updates the phone number of a technical entity.
 * @param uId (optional) The UID of the technical entity.
 * @param newPhoneNumber (optional) The new phone number to update.
 * @return An ActionResult indicating the result of the operation.
 */

  



    

    

    


  

    

    

    


  



  updatePhoneNumber(uId : string, newPhoneNumber : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Technical/UpdatePhoneNumber', { uId, newPhoneNumber }, showSpinner)
  }

  

  /**
 * Sends a map route link to a technician's email.
 * @param email (optional) The email address of the technician.
 * @param link (optional) The map route link.
 * @return An ActionResult indicating the result of the operation.
 */

  



    

    

    


  

    

    

    


  



  sendMapsRouteToTechnicianEmail(email : string, link : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Technical/SendMapsRouteToTechnicianEmail', { email, link }, showSpinner)
  }
}
export let TechnicalClient = new _TechnicalClient();

class _TestClient {

  

  



  test(showSpinner = true) : Promise<string> {
  return CommonServices.defaultGet<string>(baseUrl + 'api/Test/Test', {  }, showSpinner)
  }
}
export let TestClient = new _TestClient();

class _TicketClient {

  

  /**
 * Gets a list of live tickets.
 * @return A list of TicketVm objects.
 */

  



  getLiveTickets(showSpinner = true) : Promise<OM.TicketVm[]> {
  return CommonServices.defaultGet<OM.TicketVm[]>(baseUrl + 'api/Ticket/GetLiveTickets', {  }, showSpinner)
  }

  

  /**
 * Gets a list of previous tickets.
 * @return A list of TicketVm objects.
 */

  



  getPreviousTickets(showSpinner = true) : Promise<OM.TicketVm[]> {
  return CommonServices.defaultGet<OM.TicketVm[]>(baseUrl + 'api/Ticket/GetPreviousTickets', {  }, showSpinner)
  }

  

  /**
 * Gets a list of next tickets.
 * @return A list of TicketVm objects.
 */

  



  getNextTickets(showSpinner = true) : Promise<OM.TicketVm[]> {
  return CommonServices.defaultGet<OM.TicketVm[]>(baseUrl + 'api/Ticket/GetNextTickets', {  }, showSpinner)
  }

  

  /**
 * Gets a list of priority values.
 * @return A list of priority values as strings.
 */

  



  getPriorityList(showSpinner = true) : Promise<string[]> {
  return CommonServices.defaultGet<string[]>(baseUrl + 'api/Ticket/GetPriorityList', {  }, showSpinner)
  }

  

  /**
 * Gets a list of requestor values.
 * @return A list of requestor values as strings.
 */

  



  getRequestorList(showSpinner = true) : Promise<string[]> {
  return CommonServices.defaultGet<string[]>(baseUrl + 'api/Ticket/GetRequestorList', {  }, showSpinner)
  }

  

  /**
 * Gets a list of technicians.
 * @return A list of technician values as strings.
 */

  



  getTechniciansList(showSpinner = true) : Promise<string[]> {
  return CommonServices.defaultGet<string[]>(baseUrl + 'api/Ticket/GetTechniciansList', {  }, showSpinner)
  }

  

  /**
 * Gets a paginated list of tickets filtered by various criteria.
 * @param perPage (optional) The number of items per page.
 * @param pageNumber (optional) The page number.
 * @param time (optional) The time filter (Previous, Live, Next).
 * @param from (optional) The start date for filtering.
 * @param to (optional) The end date for filtering.
 * @param priority (optional) The priority filter.
 * @param requestor (optional) The requestor filter.
 * @param probType (optional) The problem type filter.
 * @param statusList (optional) The list of status filters.
 * @param technicians (optional) The technician filter.
 * @return A paginated response containing the filtered tickets.
 */

  



    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  

    

    

    


  



  getTicketsByFilter(perPage : number, pageNumber : number, time : string, from : string, to : string, priority : string, requestor : string, probType : OM.CanoneType, statusList : OM.TicketStatus[], technicians : string, showSpinner = true) : Promise<OM.PaginatedResponseVmOfTicketVm> {
  return CommonServices.defaultGet<OM.PaginatedResponseVmOfTicketVm>(baseUrl + 'api/Ticket/GetTicketsByFilter', { perPage, pageNumber, time, from, to, priority, requestor, probType, statusList, technicians }, showSpinner)
  }

  

  /**
 * Gets a list of live tickets for a specific technician.
 * @param cf (optional) The CF ID of the technician.
 * @return A list of TicketVm objects.
 */

  



    

    

    


  



  getLiveTicketsWithTechnical(cf : string, showSpinner = true) : Promise<OM.TicketVm[]> {
  return CommonServices.defaultGet<OM.TicketVm[]>(baseUrl + 'api/Ticket/GetLiveTicketsWithTechnical', { cf }, showSpinner)
  }

  

  /**
 * Gets a list of previous tickets for a specific technician.
 * @param cf (optional) The CF ID of the technician.
 * @return A list of TicketVm objects.
 */

  



    

    

    


  



  getPreviousTicketsWithTechnical(cf : string, showSpinner = true) : Promise<OM.TicketVm[]> {
  return CommonServices.defaultGet<OM.TicketVm[]>(baseUrl + 'api/Ticket/GetPreviousTicketsWithTechnical', { cf }, showSpinner)
  }

  

  /**
 * Gets a list of next tickets for a specific technician.
 * @param cf (optional) The CF ID of the technician.
 * @return A list of TicketVm objects.
 */

  



    

    

    


  



  getNextTicketsWithTechnical(cf : string, showSpinner = true) : Promise<OM.TicketVm[]> {
  return CommonServices.defaultGet<OM.TicketVm[]>(baseUrl + 'api/Ticket/GetNextTicketsWithTechnical', { cf }, showSpinner)
  }

  

  /**
 * Gets a list of live tickets for a specific building.
 * @param blId (optional) The building ID.
 * @return A list of TicketVm objects.
 */

  



    

    

    


  



  getLiveTicketsWithBuild(blId : string, showSpinner = true) : Promise<OM.TicketVm[]> {
  return CommonServices.defaultGet<OM.TicketVm[]>(baseUrl + 'api/Ticket/GetLiveTicketsWithBuild', { blId }, showSpinner)
  }

  

  /**
 * Gets a list of previous tickets for a specific building.
 * @param blId (optional) The building ID.
 * @return A list of TicketVm objects.
 */

  



    

    

    


  



  getPreviousTicketsWithBuild(blId : string, showSpinner = true) : Promise<OM.TicketVm[]> {
  return CommonServices.defaultGet<OM.TicketVm[]>(baseUrl + 'api/Ticket/GetPreviousTicketsWithBuild', { blId }, showSpinner)
  }

  

  /**
 * Gets a list of next tickets for a specific building.
 * @param blId (optional) The building ID.
 * @return A list of TicketVm objects.
 */

  



    

    

    


  



  getNextTicketsWithBuild(blId : string, showSpinner = true) : Promise<OM.TicketVm[]> {
  return CommonServices.defaultGet<OM.TicketVm[]>(baseUrl + 'api/Ticket/GetNextTicketsWithBuild', { blId }, showSpinner)
  }

  

  /**
 * Gets a list of all ticket statuses.
 * @return A list of TicketStatusVM objects.
 */

  



  getAllTicketStatus(showSpinner = true) : Promise<OM.TicketStatusVM[]> {
  return CommonServices.defaultGet<OM.TicketStatusVM[]>(baseUrl + 'api/Ticket/GetAllTicketStatus', {  }, showSpinner)
  }
}
export let TicketClient = new _TicketClient();

class _VehicleClient {

  

  /**
 * Gets a list of vehicles filtered by roles.
 * @param rolesFilter The list of roles to filter by.
 * @return A list of VehicleVm objects.
 */

  



    

    

    


  



  getVehicleList(rolesFilter : string[], showSpinner = true) : Promise<OM.VehicleVm[]> {
  return CommonServices.defaultPost<OM.VehicleVm[]>(baseUrl + 'api/Vehicle/GetVehicleList', rolesFilter, { }, showSpinner)
  }

  

  /**
 * Gets a list of all vehicles that are parked.
 * @return A list of VehicleVm objects.
 */

  



  getAllVehicleList(showSpinner = true) : Promise<OM.VehicleVm[]> {
  return CommonServices.defaultGet<OM.VehicleVm[]>(baseUrl + 'api/Vehicle/GetAllVehicleList', {  }, showSpinner)
  }

  

  /**
 * Gets a filtered list of vehicles based on a search text.
 * @param searchText (optional) The search text to filter by.
 * @return A list of VehicleWithDriverVm objects.
 */

  



    

    

    


  



  getFilteredVehicleList(searchText : string, showSpinner = true) : Promise<OM.VehicleWithDriverVm[]> {
  return CommonServices.defaultGet<OM.VehicleWithDriverVm[]>(baseUrl + 'api/Vehicle/GetFilteredVehicleList', { searchText }, showSpinner)
  }

  

  /**
 * Gets the total count of vehicles.
 * @return The total count of vehicles as a string.
 */

  



  tot(showSpinner = true) : Promise<string> {
  return CommonServices.defaultGet<string>(baseUrl + 'api/Vehicle/Tot', {  }, showSpinner)
  }
}
export let VehicleClient = new _VehicleClient();

class _LocalizationClient {

  

  



  getAppDictionary(showSpinner = true) : Promise<OM.LocalizedEntity[]> {
  return CommonServices.defaultGet<OM.LocalizedEntity[]>(baseUrl + 'api/Localization/GetAppDictionary', {  }, showSpinner)
  }

  

  



  getAll(showSpinner = true) : Promise<OM.LocalizedEntity[]> {
  return CommonServices.defaultGet<OM.LocalizedEntity[]>(baseUrl + 'api/Localization/GetAll', {  }, showSpinner)
  }

  

  



  getEnabledLanguages(showSpinner = true) : Promise<string[]> {
  return CommonServices.defaultGet<string[]>(baseUrl + 'api/Localization/GetEnabledLanguages', {  }, showSpinner)
  }

  

  



  getSupportedLanguages(showSpinner = true) : Promise<string[]> {
  return CommonServices.defaultGet<string[]>(baseUrl + 'api/Localization/GetSupportedLanguages', {  }, showSpinner)
  }

  

  



    

    

    


  



  saveLocalizedValue(item : OM.KeyValuePairOfStringAndString, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/Localization/SaveLocalizedValue', item, { }, showSpinner)
  }

  

  



    

    

    


  



  editLocalizedValue(value : OM.LocalizedEntity, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/Localization/EditLocalizedValue', value, { }, showSpinner)
  }
}
export let LocalizationClient = new _LocalizationClient();

interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}